import React from "react";
import "./DosaChutneyWrapper.scss"
import Navbar from "./components/Navbar/Navbar";
import Footer from "./components/Footer/Footer";
const DosaChutneyWrapper = ({ children }) => {
    return (
        <div className="DosaChutneyWrapper">
            <Navbar />
            {children}
            <Footer />
        </div>
    )
}
export default DosaChutneyWrapper